export default function (value, abs = false) {
    if (value < 0 && !abs) {
        return '00'
    } else {
        value = Math.abs(value)
    }

    if (value.toString().length <= 1) {
        return `0${value}`
    }
    return value
}
